import React from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import { SpaceHelmet } from './SpaceHelmet';

export const FindemApplicationContainer = ({ isLoading, error, title, view = 'boost', hideHeader = false }) => (
  <Box
    width="100%"
    minHeight={['calibration', 'shared-calibration'].includes(view) ? 'calc(100vh - 140px)' : '800px'}
    sx={{
      position: 'relative',
      overflow: 'hidden',
      minHeight: '800px',
    }}
  >
    {!isLoading && !hideHeader && (
      <Flex
        sx={{
          gap: '16px',
          position: 'relative',
          alignItems: 'center',
          padding: '24px 0px 0px 24px',
        }}
      >
        <Box
          width="48px"
          height="48px"
          flexShrink={0}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <SpaceHelmet />
        </Box>
        <Box flex="1">
          <Text fontSize="18px" fontWeight="600" color="text.dark">
            {title}
          </Text>
        </Box>
      </Flex>
    )}

    {isLoading && (
      <Flex
        justifyContent="center"
        alignItems="center"
        height="100%"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'white',
          zIndex: 10,
        }}
      >
        <Flex flexDirection="column" alignItems="center" gap={3}>
          <Box
            sx={{
              '@keyframes float': {
                '0%, 100%': {
                  transform: 'translateY(0px)',
                },
                '50%': {
                  transform: 'translateY(8px)',
                },
              },
              animation: 'float 2s ease-in-out infinite',
            }}
          >
            <SpaceHelmet width={64} height={64} />
          </Box>
          <Text fontSize={2} color="text.subtle" mt="16px">
            Loading Agent...
          </Text>
        </Flex>
      </Flex>
    )}

    {error && (
      <Flex
        justifyContent="center"
        alignItems="center"
        height="100%"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'white',
        }}
      >
        {view === 'shared-calibration' && (
          <Box
            sx={{
              maxWidth: '400px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            <Text fontSize="22px" fontWeight="semibold" color="text.dark" lineHeight="normal">
              Oops! We can&apos;t open the agent
            </Text>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <Text fontSize="16px" color="text.main" lineHeight="1.5">
                Either there is an error on the URL or the agent is no longer accessible.
              </Text>
              <Text fontSize="16px" color="text.main" lineHeight="1.5">
                Double-check the URL or contact the person who shared the list with you.
              </Text>
            </Box>
          </Box>
        )}
        {view !== 'shared-calibration' && (
          <Flex flexDirection="column" alignItems="center" gap={2}>
            <Text fontSize={3} fontWeight="bold">
              Error loading the agent
            </Text>
            <Text fontSize={1} color="gray.600">
              {error.message}
            </Text>
          </Flex>
        )}
      </Flex>
    )}

    <Box
      id="findem-widget-modal"
      width="100%"
      height="100%"
      sx={{
        display: 'flex',
        position: 'relative',
        justifyContent: 'center',

        '& #findem-widget-iframe': {
          width: '100% !important',
          height: ['calibration', 'shared-calibration'].includes(view)
            ? 'calc(100vh - 140px) !important'
            : `800px!important`,
        },
      }}
    />
  </Box>
);

FindemApplicationContainer.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  title: PropTypes.string.isRequired,
  view: PropTypes.string,
  hideHeader: PropTypes.bool,
};

FindemApplicationContainer.defaultProps = {
  error: null,
  view: 'boost',
  hideHeader: false,
};
